import React from 'react';
import PageLoader from '@components/loaders/loader1';
import { loadInvoiceDataForPrintView } from './controler';
import PaginateA4Frame from './printPaginationFrame';
import { getInvoicePropertiesNeededForInvoicePreview } from '../invoicePresenter/utils';
import { translate } from '@data/translations';

import {
    GroupInvoiceDetails,
    InvoiceItemsModel,
    InvoiceModelWithInvoiceItems,
    InvoicePreview,
    ReservationModelWithModelsIncluded,
} from '@common/modelDefinition';
import { PaginateA4FrameProps } from './printPaginationFrame';
import useStore from '@data/state/zustand';

export interface InvoicePrintViewProps {
    invoice: InvoiceModelWithInvoiceItems;
    invoiceItems: InvoiceItemsModel[];
    groupInvoiceDetails?: GroupInvoiceDetails;
    invoicePreview?: InvoicePreview;
    groupReservationsArray?: ReservationModelWithModelsIncluded[];
    match?: any;
    location?: any;
    history?: any;
    invoicingSettings: any;
    invoiceRefId?:number,
}

const InvoicePrintView = (props: InvoicePrintViewProps) => {
    const invoiceId = props?.match?.params?.invoiceId;

    const invoice: InvoiceModelWithInvoiceItems = useStore((appState: any) => appState.state.invoicePresenter.invoice);
    const groupReservationsArray: ReservationModelWithModelsIncluded[] = useStore(
        (appState: any) => appState.state.invoicePresenter.groupReservationsArray
    );
    const invoicePreview: InvoicePreview = useStore((appState: any) => appState.state.invoicePresenter.invoicePreview);
    const groupInvoiceDetails: GroupInvoiceDetails = useStore(
        (appState: any) => appState.state.invoicePresenter.groupInvoiceDetails
    );
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);

    React.useEffect(() => {
        //ovdje samo okidam da se račun učita u state
        if (invoiceId) {
            loadInvoiceDataForPrintView(invoiceId);
        }
    }, [invoiceId]);


    const { InvoiceItems } = invoice;

    if (!InvoiceItems) {
        return <PageLoader />;
    }
    const newProps = {
        ...props,
        invoiceItems: InvoiceItems,
        invoice,
        groupReservationsArray,
        invoicePreview,
        groupInvoiceDetails,
        invoicingSettings,
        invoiceRefId:invoiceId
    };

    return (
        <div className="bg-light">
            <A4Frame {...newProps} />
        </div>
    );
};

const A4Frame = (props: PaginateA4FrameProps) => {
    const {
        invoice,
        location,
        history,
        groupInvoiceDetails,
        groupReservationsArray,
        invoicePreview,
        invoicingSettings,
        invoiceRefId,
    } = props;
    return (
        <div style={{ maxWidth: '900px', margin: 'auto' }} className="">
            <PaginateA4Frame {...props} />

            {groupInvoiceDetails && // 👈 null and undefined check
                Object.keys(groupInvoiceDetails).length > 0 &&
                groupInvoiceDetails.constructor === Object && (
                    <div>
                        {Object.keys(groupInvoiceDetails).map((key, index) => {
                            const invoiceItems = groupInvoiceDetails[key].invoiceItems;
                            const targetInvoice = getInvoicePropertiesNeededForInvoicePreview(
                                groupInvoiceDetails[key].invoice,
                                invoice,
                                invoiceItems
                            );
                            return (
                                <React.Fragment key={index}>
                                    <PaginateA4Frame
                                        invoice={targetInvoice}
                                        invoiceItems={invoiceItems}
                                        location={location}
                                        details={true}
                                        history={history}
                                        groupReservationsArray={groupReservationsArray}
                                        invoicePreview={invoicePreview}
                                        invoicingSettings={invoicingSettings}
                                        invoiceRefId={invoiceRefId}
                                    />
                                </React.Fragment>
                            );
                        })}
                        <div className="text-center mt-4 mb-4 d-print-none">
                            <button
                                className="btn btn-sm btn-secondary"
                                onClick={() => {
                                    useStore
                                        .getState()
                                        .setNestedProperty(['state', 'invoicePresenter', 'groupInvoiceDetails'], {});
                                }}
                            >
                                {translate('Close')}
                            </button>
                        </div>
                    </div>
                )}
        </div>
    );
};

export default InvoicePrintView;
